(function () {
  'use strict';

  const { BaseCarousel, layout, ProductForm } = window.Universe;

  class ProductPairsCarousel {
    constructor(section) {
      if (section) {
        this.init(section);
      }
    }

    setup() {
      this.instance = new BaseCarousel({
        wrap: this.DOM.section,
        carouselOptions: {
          containScroll: 'trimSnaps',
          breakpoints: {
            '(min-width: 1024px)': {
              align: 'start',
              watchDrag: false,
              loop: true,
            },
            '(max-width: 1023px)': {
              align: 'start',
              watchDrag: true,
              loop: true,
            },
            '(max-width: 767px)': {
              align: 'center',
              loop: true,
              watchDrag: true,
            },
          },
        },
        onReady: () => {
          this.instance.instance.on('select', this._onChangeSlide);

          if (this.DOM.prev.length) {
            for (let i = 0; i < this.DOM.prev.length; i++) {
              this.DOM.prev[i].addEventListener('click', this._onPrev);
            }
          }

          if (this.DOM.next.length) {
            for (let i = 0; i < this.DOM.next.length; i++) {
              this.DOM.next[i].addEventListener('click', this._onNext);
            }
          }
        },
      });
    }

    destroy() {
      if (this.DOM) {
        if (this.DOM.prev.length) {
          for (let i = 0; i < this.DOM.prev.length; i++) {
            this.DOM.prev[i].removeEventListener('click', this._onPrev);
          }
        }

        if (this.DOM.next.length) {
          for (let i = 0; i < this.DOM.next.length; i++) {
            this.DOM.next[i].removeEventListener('click', this._onNext);
          }
        }
        if (this.instance) this.instance.destroy();

        this.instance = undefined;
        this.DOM = undefined;
      }
    }

    init(section) {
      this.DOM = {};
      this.DOM.section = section;
      this.sectionId = this.DOM.section.closest('.shopify-section')?.id || null;
      this.DOM.prev = this.DOM.section.querySelectorAll('.js-carousel-prev');
      this.DOM.next = this.DOM.section.querySelectorAll('.js-carousel-next');

      this.activeIndex = layout.device >= 1 ? 0 : 1;

      this._onChangeSlide = () => {
        const nextIndex = this.instance.instance.selectedScrollSnap();
        this.activeIndex = nextIndex;
      };

      this._onPrev = () => {
        this.instance.instance.scrollPrev();
      };

      this._onNext = () => {
        this.instance.instance.scrollNext();
      };

      const url = this.DOM.section.dataset.url;

      // Note: innerHTML usage here mirrors the original source code which injects
      // Shopify product recommendations HTML from the same-origin Shopify API.
      // This is safe because the content comes from Shopify's own recommendations endpoint.
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.js-product-pairs-carousel-section');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.DOM.section.innerHTML = recommendations.innerHTML;
            this.DOM.prev = this.DOM.section.querySelectorAll('.js-carousel-prev');
            this.DOM.next = this.DOM.section.querySelectorAll('.js-carousel-next');
            const carouselContainer = this.DOM.section.querySelector('.js-recommendations-container');
            if (carouselContainer.innerHTML.trim().length) {
              this.setup();
              if (ProductForm) {
                const forms = this.DOM.section.querySelectorAll('.js-product-form');
                for (let i = 0; i < forms.length; i++) {
                  new ProductForm(forms[i]);
                }
              }
            } else {
              this.DOM.section.hidden = true;
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  window.Universe.ProductPairsCarousel = ProductPairsCarousel;
})();
